module.exports = __webpack_public_path__ + "img/patrocinadores_bernina.8b548936.png";